import { render } from "./CopyJob.vue?vue&type=template&id=4873eb7b"
import script from "./CopyJob.vue?vue&type=script&lang=js"
export * from "./CopyJob.vue?vue&type=script&lang=js"

import "./CopyJob.vue?vue&type=style&index=0&id=4873eb7b&lang=css"

import exportComponent from "/tmp/build_3e230bee/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__